import React from 'react';
import {googleMapURL} from "../../../constants/googleMaps";
import UnitMap from "../livegps/UnitMap";
import {getUnitSecurityStatus, getUnitID} from "../utils";
import {
    BatteryAlert, Build,
    Check, FastForward, Help, InfoOutline, SimCard,
    Warning, WifiTethering
} from 'material-ui-icons';
import NotificationsCard from "./cards/NotificationsCard";
import StatsCard from "./cards/StatsCard";
import RegularCard from "./cards/RegularCard";
import Table from "./cards/table/Table";
import {getCurrentTimeForCard} from "../../../utils/date";
import blue from 'material-ui/colors/blue';
import {
    Avatar, Button, Card, CardActions, CardHeader, CardMedia
} from "material-ui";

/**
 * Summary tab wrapper of the unit page
 */
export const SummaryTab = ({selectedUnit}) => {
    return (
        <div key={getUnitID(selectedUnit)} className="row">
            <div className="col-lg-8 col-md-6 col-sm-6 col-xs-12">
                <RegularCard
                    headerColor="darkblue"
                    cardTitle="Current Location"
                    cardSubtitle={getCurrentTimeForCard()}
                    content={
                        selectedUnit &&
                        <UnitMap
                            googleMapURL={googleMapURL}
                            loadingElement={<div style={{height: `100%`}} />}
                            containerElement={<div style={{height: '320px', minHeight: 150}} />}
                            mapElement={<div style={{height: `100%`}} />}
                            selectedUnit={selectedUnit}
                        />
                    }
                />
                <RegularCard
                    headerColor="darkblue"
                    cardTitle="Last Trip"
                    content={
                        <div style={{minHeight: 164}}>
                            <Card>
                                <CardHeader
                                    avatar={
                                        <Avatar aria-label="LastTrip" style={{backgroundColor: blue[500]}}>
                                            D
                                        </Avatar>
                                    }
                                    title="Dakota Rice"
                                    subheader="Apr 6 2018, 11:55 AM"
                                    action={
                                        <Button size="small" color="primary">
                                            View Details
                                        </Button>
                                    }
                                />
                                <CardMedia
                                    style={{height: 150}}
                                    image={process.env.PUBLIC_URL + '/dummymap.png'}
                                    title="Last Trip"
                                />
                            </Card>
                        </div>
                    }
                />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <StatsCard
                    icon={FastForward}
                    iconColor="navy"
                    title="Current Speed"
                    description="0"
                    small="mph"
                    statIcon={Check}
                    statIconColor="success"
                    statLink={{ text: "Stationary" }}
                />
                <StatsCard
                    icon={selectedUnit && (getUnitSecurityStatus(selectedUnit)) === 'Disarmed' ? InfoOutline : Warning}
                    iconColor={selectedUnit && (getUnitSecurityStatus(selectedUnit)) === 'Disarmed' ? "green" : "red"}
                    title="Alert Status"
                    description={selectedUnit && getUnitSecurityStatus(selectedUnit)}
                    statIcon={Help}
                    statLink={{ text: "Disarmed: Not recording" }}
                />
                <StatsCard
                    icon={BatteryAlert}
                    iconColor="green"
                    title="Battery Status"
                    description="Good"
                    statIcon={Check}
                    statIconColor="success"
                    statLink={{ text: "No action necessary" }}
                />
                <StatsCard
                    icon={Build}
                    iconColor="green"
                    title="Engine Status"
                    description="Good"
                    statIcon={Check}
                    statIconColor="success"
                    statLink={{ text: "No action necessary" }}
                />
                <StatsCard
                    icon={WifiTethering}
                    iconColor="navy"
                    title="Connection"
                    description="Moderate"
                    statIcon={SimCard}
                    statLink={{ text: "AT&T LTE" }}
                />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <NotificationsCard
                    selectedUnit={selectedUnit}
                    headerColor="darkblue"
                />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <RegularCard
                    headerColor="darkblue"
                    cardTitle="Driver Rating"
                    content={
                        <div className="text-center">
                            <Table
                                tableHeaderColor="gray"
                                tableHead={["ID", "Name", "Last Driven", "Driver Score"]}
                                tableData={[
                                    ["1", "Dakota Rice", "Apr 6, 11:55 AM", "4.63/5"],
                                    ["2", "Minerva Hooper", "Mar 29, 5:27 PM", "3.20/5"],
                                    ["3", "Sage Rodriguez", "Mar 28, 10:30 AM", "4.02/5"],
                                    ["4", "Philip Chaney", "Feb 2, 7:03 PM", "3.93/5"]
                                ]}
                            />
                            <div className="btn btn-light btn-sm mt-2">View Vehicle History</div>
                        </div>
                    }
                />
            </div>
        </div>
    );
};





// WEBPACK FOOTER //
// ./src/components/unit/summary/SummaryTab.jsx